import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Replace these values with your actual Firebase project settings
const firebaseConfig = {
  apiKey: "AIzaSyDxPx7fqnsNXtWlOP47HOjeNkVXMHfjnXk",
  authDomain: "inquiry-da7a8.firebaseapp.com",
  projectId: "inquiry-da7a8",
  storageBucket: "inquiry-da7a8.firebasestorage.app",
  messagingSenderId: "671165208274",
  appId: "1:671165208274:web:45b123f06f49ed06777f0b",
  measurementId: "G-WD25R82D7K"
};


const app = initializeApp(firebaseConfig);
// Export the database instance to use in other files
export const db = getFirestore(app);